export default "__VITE_ASSET__b0d1beb1__"